export const CURRENT_YEAR_PLACEHOLDER = 'CURRENT_YEAR_PLACEHOLDER';
export const INTRODUCTION = [
  {
    text: `Autodesk Construction Cloud © ${CURRENT_YEAR_PLACEHOLDER}, Inc. All rights reserved.`,
    type: 'bold',
  },
  {
    text: 'All use of this Software is subject to the Autodesk terms of service accepted upon access or use of this Service or made available on the Autodesk webpage. Autodesk terms of service for Autodesk’s various web services can be found <a href="https://www.autodesk.com/company/legal-notices-trademarks/terms-of-service-autodesk360-web-services">here</a>.',
    type: 'bold',
  },
  {
    text: 'Privacy',
    type: 'bold',
  },
  {
    text: 'To learn more about Autodesk’s online and offline privacy practices, please see the Autodesk <a href="http://www.autodesk.com/company/legal-notices-trademarks/privacy-statement">Autodesk Privacy Statement</a>.',
  },
  {
    text: 'Autodesk Trademarks',
    type: 'bold',
  },
  {
    text: 'The trademarks on the <a href="https://www.autodesk.com/company/legal-notices-trademarks/intellectual-property/trademarks">Autodesk Trademarks</a> page are registered trademarks or trademarks of Autodesk, Inc., and/or its subsidiaries and/or affiliates in the USA and/or other countries.',
  },
  {
    text: 'All other brand names, product names or trademarks belong to their respective holders.',
    type: 'bold',
  },
  {
    text: 'Patents',
    type: 'This Service is protected by patents listed on the <a href="https://www.autodesk.com/company/legal-notices-trademarks/patents">Autodesk Patents</a> page.',
  },
  {
    text: 'Autodesk Cloud and Desktop Components',
    type: 'bold',
  },
  {
    text: 'This Service may incorporate or use background Autodesk online and desktop technology components. For information about these components, see <a href="https://www.autodesk.com/company/legal-notices-trademarks/autodesk-cloud-platform-components">Autodesk Cloud Platform Components</a> and <a href="https://www.autodesk.com/company/legal-notices-trademarks/autodesk-desktop-platform-components">Autodesk Desktop Platform Components</a>.',
    type: 'bold',
  },
];
